import { derived, writable } from "svelte/store";
import type {
    UserData,
} from "@hitit/api";
import { store } from "@hitit/hub/src/stores";
import { storeLogos } from "@hitit/hub/src/v7/store";
import axios from "axios";

export const selectedUser = writable<UserData | undefined>(undefined);
export const selectedStoreLogo = (() => {
    const defaultImage = storeLogos.getDefaultImage()
    const logo = writable<string>(defaultImage);
    const { subscribe, update, set } = logo
    store.subscribe(async (v) => {
        if (v === undefined) return;
        const storeId = v.id;
        getStoreImage(storeId)

    })

    async function getStoreImage(storeId: string) {
        try {
            const url = `${"HITIT_IMAGE_URL"}logo/${storeId}.png?v=${Date.now()}`;
            const response = await axios.get(url, {
                withCredentials: true,
                responseType: "blob",
            });
            if (!response.data) throw new Error("None Data");
            const image = URL.createObjectURL(response.data)
            set(image);
        } catch (error) {
            set(defaultImage)
        }
    }

    return {
        subscribe,
        update,
    }
})()